<div class="dialog-container">
    @if (loading) {
    <div class="loader-overlay">
        <div class="loader" id="loader-4">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    }

    <div class="docket-header">
        <h2>{{ modalDocketHeader }}</h2>
        <button type="button" class="close-btn" (click)="onClose()">
            &times;
        </button>
    </div>

    <div class="docket-description">
        <h4>{{ modalDocketSubHeading }}</h4>
    </div>
    <form #contactusform="ngForm">
        <!-- Client Name -->
        <div class="form-row">
            <label>* Client/Project Name:</label>
            <div>
                <input type="text" name="clientname" [(ngModel)]="contactmodel.clientname" #clientname="ngModel"
                    required class="form-control docket-input" placeholder="Client/Project Name">
                @if(clientname.invalid && (clientname.touched || contactusform.submitted)) {
                <div class="validation-error">
                    Valid ClientName is required
                </div>
                }
            </div>
        </div>

        <!-- Client Market -->
        <div class="form-row">
            <label>* Client's Market:</label>
            <div>
                <select class="form-control docket-input" name="clientmarket" [(ngModel)]="contactmodel.clientmarket"
                    #clientmarket="ngModel" required>
                    <option value="">
                        Select Client Market
                    </option>
                    @for (item of clientmarketlist; track $index) {
                    <option [value]="item.GeoId">
                        {{ item.GeoDesc }}
                    </option>
                    }
                </select>
                @if(clientmarket.invalid && (clientmarket.touched || contactusform.submitted)) {
                <div class="validation-error">
                    Please select valid Clientmarket
                </div>
                }

            </div>
        </div>

        <!-- Client Industry -->
        <div class="form-row">
            <label>* Client's Industry:</label>
            <div>
                <select class="form-control docket-input" name="clientindustry"
                    [(ngModel)]="contactmodel.clientindustry" #clientindustry="ngModel" required>
                    <option value="">
                        Select Client Industry
                    </option>

                    @for (item of clientindustrylist; track $index) {
                    <option [value]="item.IgId">
                        {{ item.IgDesc }}
                    </option>
                    }

                </select>

                @if(clientindustry.invalid && (clientindustry.touched || contactusform.submitted)) {
                <div class="validation-error">
                    Please select valid Clientindustry
                </div>
                }
            </div>
        </div>
        <!-- Use Case -->
        <div class="form-row">
            <label>* Use Case:</label>
            <div>
                <select class="form-control docket-input" name="usecase" [(ngModel)]="contactmodel.usecase"
                    #usecase="ngModel" required>
                    <option value="">
                        Select Use Case
                    </option>
                    @for (item of usecaselist; track $index) {
                    <option [value]="item.UseCaseId">
                        {{ item.UseCaseDesc }}
                    </option>
                    }
                </select>
                @if(usecase.invalid && (usecase.touched || contactusform.submitted)) {
                <div class="validation-error">
                    Please select valid Usecase
                </div>
                }
            </div>
        </div>
        <!-- Opportunity -->
        <div class="form-row">
            <label>* Opportunity ID (OM/MMS):</label>
            <div>
                <input type="text" class="form-control docket-input" placeholder="[OM/MMS ID]" name="oppurtunityId"
                    [(ngModel)]="contactmodel.oppurtunityId" #oppurtunityId="ngModel" required pattern="^[0-9]{10}$">
                @if(oppurtunityId.invalid && (oppurtunityId.touched || contactusform.submitted)) {
                <div class="validation-error">
                    A valid 10 digit Opportunity ID must be entered.
                </div>
                }
            </div>
        </div>
        <!-- Deal Value -->

        <div class="form-row">
            <label>* Deal Value:</label>
            <div>
                <input type="text" class="form-control docket-input" placeholder="Deal Value" name="dealValue"
                    [(ngModel)]="contactmodel.dealValue" #dealValue="ngModel" required>
                @if(dealValue.invalid && (dealValue.touched || contactusform.submitted)) {
                <div class="validation-error">
                    Valid Deal Value is required
                </div>
                }
            </div>
        </div>

        <!-- Additional Information -->

        <div class="form-row">
            <label>Additional Information:</label>
            <div>
                <textarea class="form-control docket-input" rows="4" name="additionalinfo"
                    [(ngModel)]="contactmodel.additionalinfo" placeholder="Additional Information">
            </textarea>
            </div>
        </div>

        <!-- Buttons -->

        <div class="button-section">
            <button type="button" class="download-btn" [disabled]="contactusform.invalid" (click)="onSubmit()">
                Download
            </button>
            <button type="button" class="reset-btn" (click)="formreset()">
                Reset
            </button>
        </div>
    </form>
</div>